export default __webpack_public_path__ + "../staticImages/bester-online-weinfachhaendler-2021.png";